import { createActions, handleActions } from "redux-actions";
import { normalize } from "normalizr";

import { getData, getSlugId } from "../utilities";
import { story, storeStories, resetStories } from "./stories";

/*
 *** ACTION CREATORS
 */

const actions = createActions({
  STORY_PAGE: {
    REQUEST: [(payload) => payload, (_, slug) => ({ slug })],
    RESPONSE: [(payload) => payload, (_, slug) => ({ slug })],
  },
});

/*
 *** THUNKS
 */

export const fetchStoryPage = (slug, previewToken, subscriberAccessCode) => (dispatch) => {
  dispatch(actions.storyPage.request(undefined, slug));

  return getData(`/stories/by-slug/${slug}/${previewToken ? previewToken : ""}${subscriberAccessCode ? "?subscriber_access_code=" + subscriberAccessCode : ""}`)
    .then(async (res) => {
      if (res.status === 404) {
        return dispatch(
          actions.storyPage.response(new Error(res.status), slug)
        );
      }

      if (res.status !== 200) {
        return dispatch(
          actions.storyPage.response(new Error(res.statusText), slug)
        );
      }

      const results = (await res.json()).results;
      const contextual_stories = normalize(results.contextual_stories, [story]);
      results.contextual_stories = contextual_stories.result;
      const contextual_carousel = normalize(results.contextual_carousel, [
        story,
      ]);
      results.contextual_carousel = contextual_carousel.result;
      const storyPage = normalize(results, story);

      dispatch(
        storeStories({
          ...contextual_stories.entities.stories,
          ...contextual_carousel.entities.stories,
          ...storyPage.entities.stories,
        })
      );

      return dispatch(actions.storyPage.response(undefined, slug));
    })
    .catch((error) => dispatch(actions.storyPage.response(error, slug)));
};

/*
 *** REDUCERS
 */

export default handleActions(
  new Map([
    [
      actions.storyPage.request,
      (state, { meta }) => ({
        ...state,
        [getSlugId(meta.slug)]: { isFetching: true, error: null },
      }),
    ],
    [
      actions.storyPage.response,
      (state, { error, payload, meta }) => {
        if (error) {
          return {
            ...state,
            [getSlugId(meta.slug)]: {
              isFetching: false,
              error: payload.message,
            },
          };
        }

        return {
          ...state,
          [getSlugId(meta.slug)]: {
            isFetching: false,
            error: null,
            isLoaded: true,
          },
        };
      },
    ],
    [resetStories, () => ({})],
  ]),
  {}
);

/*
 *** SELECTORS
 */

export const getStoryPage = (state, slug, storiesBySlug) => {
  const slugId = getSlugId(slug);
  const storyPage = state[slugId];

  if (!storyPage) {
    return {
      isFetching: false,
      error: null,
      isLoaded: false,
    };
  }

  let story;
  if (storyPage.isLoaded) {
    story = { ...storiesBySlug[slugId] };
    story.contextual_stories = story.contextual_stories.map(
      (slug) => storiesBySlug[slug]
    );
    story.contextual_carousel = story.contextual_carousel.map(
      (slug) => storiesBySlug[slug]
    );
  }

  return {
    isFetching: storyPage.isFetching,
    error: storyPage.error,
    isLoaded: storyPage.isLoaded || false,
    story,
  };
};
